import { getFeaturedArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import { Link } from 'react-router-dom';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              精选文章
            </h2>
            <p className="text-foreground-600 mt-2 text-sm">
              编辑推荐的深度解析内容
            </p>
          </div>
          <Link
            to="/category/plot-analysis"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {featured.slice(0, 4).map((article) => (
            <ArticleCard key={article.id} article={article} variant="featured" />
          ))}
        </div>
      </div>
    </section>
  );
}